import React, { useState } from "react"
import { Container, Card, CardBody } from "reactstrap"
import MetaTags from 'react-meta-tags';

import * as reportsApi from '../../apis/reportsApi';
import PageTitle from "../../components/Common/PageTitle"
import FilterCompany from "./FilterComponent/FilterCompany"
import FilterFromToDate from "./FilterComponent/FilterFromToDate"
import ReportBody from "./ReportPartials/ReportBody";
import ReportButton from "./ReportPartials/ReportButton";
import ReportButtonContainer from "./ReportPartials/ReportButtonContainer";


function BcDoanhSoKho() {

  const [dataHead, setDataHead] = useState([]);
  const [dataBody, setDataBody] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  const handleChangeCompany = (value) => {
    setSelectedCompany(value);
  };

  const handleChangeFromDate = (value) => {
    setFromDate(value);
  };

  const handleChangeToDate = (value) => {
    setToDate(value);
  };
    
  const renderTable = () => {
    if (selectedCompany !== undefined) {
      const params = [
          { name: "company_id", value: selectedCompany },
          { name: "from_date", value: fromDate },
          { name: "to_date", value: toDate }
      ];
      reportsApi.getDataReportsDsKho(params, getDataView, showErr);
    } else {
      alert("Chọn hệ thống cửa hàng");
    }
  }

  const getDataView = (res) => {
    setDataHead(res?.data?.data?.headers);
    setDataBody(res?.data?.data?.details);
  }

  const showErr = (res) => {
    alert(getMessage(res.message));
  }

  return (
    <React.Fragment>
      <div className="page-content">
      <MetaTags>
          <title>DS kho</title>
        </MetaTags>
        <Container fluid>
          <PageTitle title="Doanh số kho" />
            <Card>
              <CardBody>
                <FilterCompany
                  onChange={handleChangeCompany} />

                <FilterFromToDate
                  onChangeFromDate={handleChangeFromDate}
                  onChangeToDate={handleChangeToDate} />
                
                <ReportButtonContainer>
                  <ReportButton
                    label='Xem báo cáo'
                    onClick={renderTable} />
                </ReportButtonContainer>
                
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <ReportBody 
                  dataHead={dataHead}
                  dataBody={dataBody} />
              </CardBody>
            </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BcDoanhSoKho
